import { Box, Avatar } from "@mui/material";
import { useAuthContext } from "../../contexts";
import { BellIcon } from "../../icons";
import { UserStatusViewProps } from "./UserStatusView";

export function UserStatusViewV2({ onClick = () => {} }: UserStatusViewProps) {
  const { user } = useAuthContext();

  return (
    <Box display="flex" onClick={onClick} alignItems="center" sx={{ position: "relative", cursor: "pointer", flexDirection: "row-reverse", gap: "1.125rem" }}>
      <Avatar
        sx={{
          borderRadius: "1.125rem",
          width: "3.125rem",
          height: "3.125rem",
          flexGrow: 0,
        }}
        src="/assets/images/avater.png"
      >
        {`${user?.firstName.substring(0, 1)}${user?.lastName.substring(0, 1)}`}
      </Avatar>
      <Box display="flex" flexDirection="column" flexGrow={1} sx={{ whiteSpace: "nowrap" }}>
        <Box sx={{ fontSize: "0.75rem", fontWeight: 500 }}>Welcome back,</Box>
        <Box sx={{ fontSize: "0.875rem", fontWeight: 700 }}>{user?.firstName ? `${user.firstName} ${user.lastName}` : user?.email}</Box>
      </Box>
    </Box>
  );
}
